<template>
  <div class="comp-drag-item"
    v-bind:data-id="draggable.id"
    v-bind:data-label="draggable.label"
    v-if="!draggable.isDropped"
  >
    <div class="drag-wrap"
      v-bind:style="{
        backgroundImage: 'url(' + require('../../assets/' + draggable.imagePath) + ')',
        backgroundSize: draggable.imageAttr.size,
        backgroundPosition: draggable.imageAttr.left + ' ' + draggable.imageAttr.top,
        backgroundColor: draggable.imageAttr.color
      }"
      v-bind:tabindex="tabbingIndex"
      aria-haspopup="true"
      v-bind:aria-grabbed="isGrabbed.toString()"
      v-bind:aria-owns="draggable.id"
      @click="!isGrabbed && showDropInit"
      @keyup="displayDropZones"
    >
      <p><slot></slot>{{draggable.label}}</p>
    </div>
    <div class="pop-menu"
      role="menu"
      v-bind:id="draggable.id"
      v-show="draggable.hasDropList"
    >
      <button role="button" class="label"
        v-for="(dropTarget, key, index) in content.data.droppables"
        v-bind:key="key"
        v-bind:tabindex="tabbingIndex"
        v-focus="secFocus && index === 0"
        @blur="lastFocus = false"
        @focus="lastFocus = true"
        v-bind:aria-label="'Place to ' + dropTarget.label"
        @click="triggerDrag(key)"
        @keydown="moveTabIndex"
      >
        {{dropTarget.label}}
      </button>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import 'jquery-ui/ui/widgets/draggable'
import 'jquery-ui/ui/widgets/droppable'
import { focus } from 'vue-focus'

export default {
  name: 'DragItem',
  directives: { focus: focus },
  data () {
    return {
      showDrop: false,
      initFocus: false,
      secFocus: false,
      lastFocus: false,
      isGrabbed: false
    }
  },
  props: {
    dataId: {
      type: String,
      required: true
    },
    dataKey: {
      type: String,
      required: true
    },
    tabbingIndex: {
      type: Number,
      required: true
    }
  },
  watch: {
    lastFocus () {
      if (!this.lastFocus) {
        this.content.data.draggables[this.dataKey].hasDropList = false
      }
    }
  },
  computed: {
    content () {
      return this.$store.getters.getData(this.dataId)
    },
    draggable () {
      return this.content.data.draggables[this.dataKey]
    }
  },
  created () {
    this.$eventHub.$on('tab-pressed', () => {
    })
  },
  mounted () {
    $(this.$el).draggable({
      revert: 'invalid',
      containment: 'document',
      stack: '.comp-drag-item',
      cursor: 'move',
      start: (e, ui) => {
        console.log(e.target)
        $(e.target).unbind('click')
        this.$off(['click'])
        e.stopPropagation()
        this.isGrabbed = true
      },
      stop: (e, ui) => {
        this.isGrabbed = false
      }
    })
  },
  methods: {
    displayDropZones (e) {
      if (e.keyCode === 32) {
        this.showDropInit()
      } else if (e.keyCode === 9) {
        this.isGrabbed = false
      }
    },
    showDropInit () {
      this.$emit('showDrop', '')
      this.secFocus = true
      this.lastFocus = true
      this.isGrabbed = true
      this.content.data.draggables[this.dataKey].hasDropList = true
    },
    moveTabIndex (e) {
      var fireEvent = $.Event('keyup')
      console.log(e)
      fireEvent.which = 9
      console.log(fireEvent)
      if (e.keyCode === 38) {
        $(e.target).prev().focus()
      } else if (e.keyCode === 40) {
        $(e.target).next().focus()
      }
    },
    triggerDrag (droppableKey) {
      let acceptedKeys = this.content.data.droppables[droppableKey].accepted_keys
      for (let i = 0; i < acceptedKeys.length; i++) {
        if (this.dataKey === acceptedKeys[i]) {
          this.draggable.isDropped = true
          this.content.data.droppables[droppableKey].content.push(this.draggable)
          this.$emit('componentDrop', this.dataKey)
          delete this.content.data.draggables[this.dataKey]
          break
        }
      }
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/draggable-item/DraggableItem.vue